// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1510":"3b0c7683","3345":"02dcd810","5064":"334a5d28","5179":"3b0c7683","5256":"3eec6097","7465":"3b0c7683","8054":"8fa0de3d","9236":"334a5d28","9944":"3eec6097"}[chunkId] + ".chunk.css";
};